export default "__VITE_ASSET__CBQqpUxr__$_?url__"